/**
 * formatRelative — formattiert ein ISO-datum als relative-deutsche-zeitangabe.
 *
 * Pluralization-fix (phase 14): "vor 1 Wochen" → "vor 1 Woche" (singular).
 * Locale: de-DE (über `toLocaleDateString` für absolute fallbacks).
 *
 * Schwelle:
 *   - <0 oder 0 tage → "heute"
 *   - 1 tag           → "gestern"
 *   - 2..6 tage       → "vor N Tagen"
 *   - 7..29 tage      → "vor 1 Woche" / "vor 2 Wochen" / ...
 *   - ≥30 tage        → absolutes datum dd.mm.yyyy
 */
export function formatRelative(iso: string): string {
  const d = new Date(iso);
  const diffMs = Date.now() - d.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (days <= 0) return "heute";
  if (days === 1) return "gestern";
  if (days < 7) return `vor ${days} ${days === 1 ? "Tag" : "Tagen"}`;
  if (days < 30) {
    const weeks = Math.floor(days / 7);
    return `vor ${weeks} ${weeks === 1 ? "Woche" : "Wochen"}`;
  }
  return d.toLocaleDateString("de-DE");
}
